import RubberStampOverlay from './RubberStampOverlay';

export default RubberStampOverlay;